import { ChangeDetectorRef, Component, forwardRef, ViewEncapsulation, ChangeDetectionStrategy, AfterViewChecked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { VrInput } from './models/vr-input';

const VRC_INPUT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => VrcInputComponent),
  multi: true
};

@Component({
  selector: 'vrc-input',
  templateUrl: './vrc-input.component.html',
  styleUrls: ['./vrc-input.component.scss'],
  providers: [VRC_INPUT_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrcInputComponent extends VrInput implements AfterViewChecked {

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

}
